import React from 'react';

import IconClose from '@repo/ui-icons/IconClose';
import SearchIcon from '@repo/ui-icons/IconSearch';

import { Button } from '../../Button';
import { BasicInput } from '../BasicInput/BasicInput';
import { RootWrapper } from '../RootWrapper';
import { Slot } from '../Slot';
import type { TextInputProps } from '../types';

import { useBasicTextInputProps } from './useBasicTextInputProps';
import './SearchInput.module.css';

const getButtonSize = (inputSize: TextInputProps['size']) => {
  if (inputSize === 's' || inputSize === 's-condensed') {
    return 'xs';
  }
  if (inputSize === 'm') {
    return 's';
  }
  return 'm';
};

/**
 * A search input with a search icon and a clear button.
 */
export const SearchInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => {
    const { basicInputProps, handleChanged } = useBasicTextInputProps(props);
    const value = basicInputProps.value;

    const handleClear = () => {
      handleChanged('');
    };

    return (
      <RootWrapper {...props}>
        <BasicInput
          ref={ref}
          type="search"
          {...basicInputProps}
          data-testid="search-input"
        />
        <Slot>
          {value ? (
            <Button
              ariaLabel="Clear search input"
              leftIcon={IconClose}
              name="clearSearchButton"
              size={getButtonSize(props.size)}
              variant="ghost"
              onClick={handleClear}
            />
          ) : (
            <SearchIcon />
          )}
        </Slot>
      </RootWrapper>
    );
  }
);

SearchInput.displayName = 'SearchInput';
